import { EnvironmentInjector, signal } from '@angular/core';

import { LazyComponentDetails } from '@core/shared/util';
import { ComponentPluginComponent } from '@mp/shared/component-plugins/util';
import type { AddressEditTabPlugin, AddressEditTabPluginInput } from '@mpomd/shared/util';

export function createAddressEditTabPlugin(): AddressEditTabPlugin {
  return {
    label: 'Lieferanten Adresscodes',
    // NOTE: There is no permission check as of now.
    isEnabled: signal(true),
    async getComponentDetails(
      parentInjector: EnvironmentInjector,
    ): Promise<LazyComponentDetails<ComponentPluginComponent<AddressEditTabPluginInput>>> {
      const addressEditFeature = await import('../components');

      return {
        component: addressEditFeature.ClinicSupplierAddressCodesComponent,
        environmentInjector: parentInjector,
      };
    },
  };
}
